import { render } from "./CharTabSR.vue?vue&type=template&id=20787dcc"
import script from "./CharTabSR.vue?vue&type=script&lang=js"
export * from "./CharTabSR.vue?vue&type=script&lang=js"

import "./CharTabSR.vue?vue&type=style&index=0&id=20787dcc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__